var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(`background-color: var(${_vm.color})`)},[_vm._v(_vm._s(_vm.tag.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }